/* global axios */
import ApiClient from './ApiClient';

class SalesTransactionDocumentsAPI extends ApiClient {
  constructor() {
    super('sales_transactions', { accountScoped: true });
  }

  list(transactionId) {
    return axios.get(`${this.url}/${transactionId}/documents`);
  }

  catalog(transactionId) {
    return axios.get(`${this.url}/${transactionId}/documents/catalog`);
  }

  upload(transactionId, file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${transactionId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  }

  signedUrl(transactionId, documentId) {
    return axios.post(
      `${this.url}/${transactionId}/documents/${documentId}/signed_url`
    );
  }

  analyzeOnus(transactionId, documentId, analysisToken) {
    return axios.post(
      `${this.url}/${transactionId}/documents/${documentId}/onus_analysis`,
      analysisToken ? { analysis_token: analysisToken } : {}
    );
  }

  update(transactionId, documentId, documentTypes) {
    return axios.patch(`${this.url}/${transactionId}/documents/${documentId}`, {
      document_types: documentTypes,
    });
  }

  remove(transactionId, documentId) {
    return axios.delete(`${this.url}/${transactionId}/documents/${documentId}`);
  }
}

export default new SalesTransactionDocumentsAPI();
